import axios from 'axios'
import setupInterceptors from './interceptors'

setupInterceptors()

export default {
  getArticles () {
    return axios.get('/api/articles')
  },
  getArticle (uri) {
    return axios.get(`/api/article/${uri}`)
  },
  getArticleHistory (uri) {
    return axios.get(`/api/article/${uri}/history`)
  },
  deleteArticle (uri, childrenAction, note) {
    return axios.delete(`/api/article/${uri}?children=${childrenAction}`, { data: { note } })
  },
  createArticle (uri, data) {
    return axios.post(`/api/article/${uri}`, data)
  },
  editArticle (uri, data, isRestore) {
    return axios.patch(`/api/article/${uri}${isRestore ? '?restore' : ''}`, data)
  },
  getRoleList () {
    // VUE_APP_OAUTH_SERVER has / on it already. This is caused by the security package requiring this.
    const server = process.env.VUE_APP_OAUTH_SERVER
    return axios.get(`${server}api/roles/all`)
  },
  search (queryString, field) {
    const query = field === '' ? queryString : `${queryString}&field=${field}`
    return axios.get(`/api/search?query=${query}`)
  }
}
